import styles from './Button.module.scss';

import { useHapticFeedback } from '@/hooks/useHapticFeedback';
import cn from 'classnames';

import type {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  SyntheticEvent,
} from 'react';

type Props = {
  onClick?: (e: SyntheticEvent<HTMLButtonElement>) => void;
  secondary?: boolean;
  outlined?: boolean;
  gradient?: boolean;
} & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export const Button = ({
  className,
  onClick,
  children,
  disabled,
  secondary,
  outlined,
  gradient,
  ...rest
}: Props) => {
  const { triggerHapticFeedback } = useHapticFeedback();
  const handleClick = (e: SyntheticEvent<HTMLButtonElement>) => {
    triggerHapticFeedback('medium');
    onClick?.(e);
  };
  return (
    <button
      type={rest.type}
      disabled={disabled}
      onClick={handleClick}
      className={cn(
        className,
        styles.button,
        secondary && styles.secondary,
        outlined && styles.outlined,
        gradient && styles.gradient,
      )}
    >
      {children}
    </button>
  );
};
